module.exports = __webpack_public_path__ + "static/media/sun-is-wrong.a8430690.mp3";